import * as Cesium from "cesium";

/**
 * Function to get the arrow material for a Cesium entity. Returns yellow arrow when system is selected (highlights the path)
 * @param {boolean} isPreview - Flag indicating if layer is in preview mode.
 * @returns {Cesium.PolylineArrowMaterialProperty} - The arrow material property.
 */

export const getArrowMaterial = (isPreview: boolean | undefined) => {
	return isPreview
		? new Cesium.PolylineArrowMaterialProperty(Cesium.Color.BLACK)
		: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.YELLOW);
};
